module.exports = __webpack_public_path__ + "images/emoji/squirrel.0bf1d3de309a89d9ed70.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/squirrel.png
// module id = PEC6
// module chunks = 1